import React, { useState } from 'react';
import './CardPasswordPopup.css';

const CardPasswordPopup = ({ visible, onSubmit, onCancel, password, setPassword }) => {
  

  if (!visible) return null;

  return (
    <div className="card-password-popup__overlay">
      <div className="card-password-popup__modal">
        <h2 className="card-password-popup__title">Enter Card Password</h2>
        <p className="card-password-popup__desc">To complete this payment, enter your card password.</p>

        <input
          type="password"
          maxLength={12}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="card-password-popup__input"
          placeholder="••••••••"
          autoFocus
        />

        <div className="card-password-popup__actions">
          <button className="card-password-popup__btn cancel" onClick={onCancel}>Cancel</button>
          <button className="card-password-popup__btn submit" onClick={() => onSubmit(password)}>Submit</button>
        </div>
      </div>
    </div>
  );
};

export default CardPasswordPopup;
